<template>
  OrderList:
  <span v-if="!p_list.length" @click="generatePoolList()"
    ><i class="bi bi-card-checklist text-primary"></i>
  </span>

  <span v-else>
    <i
      class="bi bi-chevron-down text-primary"
      @click="toggleEditList()"
      v-if="!show_edit"
    ></i>
    <i
      class="bi bi-chevron-up text-danger"
      @click="toggleEditList()"
      v-else
    ></i>
    <EditList
      v-if="show_edit"
      :list="p_list"
      :pool_id="props.pool_id"
      @list-deleted="fetchPoolLists()"
      @sort-update="doubleToggle()"
    ></EditList>
  </span>
</template>
<script setup>
import {
  defineProps,
  onBeforeMount,
  onMounted,
  ref,
  computed,
  defineEmits,
} from "vue";
import { useStore } from "@/store/index";
import EditList from "./EditList.vue";
import supabase from "@/supabase/config";
const props = defineProps(["pool_id"]);
const emit = defineEmits(["poollistGenerated"]);
const p_list = ref([]);
const show_edit = ref(false);
const toggleEditList = () => {
  show_edit.value = !show_edit.value;
};
const store = useStore();
onBeforeMount(() => {
  fetchPoolLists();
});

const fetchPoolLists = async () => {
  let { data: pool_list, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("pool_id", props.pool_id);
  p_list.value = pool_list;
};

const generatePoolList = async () => {
  var local_err = [];
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("pool_id", props.pool_id);
  if (error) {
    local_err.push(error.message);
  }
  var shuffled_players = shuffleArray([...players]);

  shuffled_players.forEach(async (sp, index) => {
    var poolListObj = {
      auction_id: store.live_auction,
      pool_id: props.pool_id,
      sort: index + 1,
      player_id: sp.id,
    };
    const { data, error } = await supabase
      .from("pool_list")
      .insert([poolListObj])
      .select();
    if (error) {
      local_err.push(error.message);
    }
  });
  if (!local_err.length) {
    emit("poollistGenerated");
  }
};
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    // Swap elements i and j
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
const doubleToggle = () => {
  toggleEditList();
  fetchPoolLists();
  setTimeout(() => {
    toggleEditList();
    emit("poollistGenerate"); //this is to force a re-render of all lists
  }, 500);
};
</script>
